import { supabase } from "@shared/lib/supabase/client";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { toast } from "sonner";

type TLogin = {
  email: string;
  password: string;
};

export function useSignIn() {
  const router = useRouter();
  return useMutation({
    mutationFn: async (payload: TLogin) => {
      const { error } = await supabase.auth.signInWithPassword(payload);
      if (error) {
        toast.error(error.message);
        throw new Error(error.message);
      } else await router.invalidate();
    },
  });
}

export function useSignOut() {
  const router = useRouter();

  return useMutation({
    mutationFn: async () => {
      const { error } = await supabase.auth.signOut();
      if (error) {
        toast.error(error.message);
        throw new Error(error.message);
      } else await router.invalidate();
    },
  });
}
